export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9018.f227514e.jpg";